fx.ns("shared.popups", class RegistrationPopup extends shared.popups.BasePersonPopup{
    
    constructor(data)
    {
        super(data, fx.get("assets").personSure);
        this.contentWidth = 500;
        // taller when the browser social buttons are shown (hidden in the app webview)
        this.contentHeight = fx.get("flutter") ? 375 : 470;
        this.effect = "";
    }

    create()
    {
        super.create();
 
        // title
        this.addChild(new fx.components.Text({text:fx.text("Sauvegarder votre ouvrage"), className:"title"}));

        // inputs
        this.loginInput = new fx.components.Input({placeHolder:fx.text("Entrez votre email")});
        this.addChild(this.loginInput, {height:60, width:"100%"});

        this.passwordInput = new fx.components.Input({placeHolder:fx.text("Choisissez votre mot de passe"), type:"password", name:"password", })
        this.addChild(this.passwordInput, {height:60, width:"100%"});

        // error
        this._error = new fx.components.Text({className:"error hidden"});
        this.addChild(this._error, {width:"100%", height:26 });

        // botton    
        this.okButton = new fx.components.Button({label : fx.text("Sauver"), type : "filled" , className:"loginButton"});
        this.addChild(this.okButton, {width : 200});

        // login string
        /*this.login = new fx.components.Text({text:fx.text("Vous possedez deja un compte?"), className:"link account-switch"});
        this.addChild(this.login, {width:"100%"});*/


        // social sign-in (browser only; the app webview uses the native auth modal)
        if (!fx.get("flutter"))
        {
            this.addChild(new fx.components.Text({text:fx.text("OU"), className:"or-separator"}), {width:"100%", height:22});

            this.googleButton = new fx.components.Button({label:fx.text("Continuer avec Google"), type:"borderOnly", className:"social-login-btn social-login-btn--google"});
            this.addChild(this.googleButton, {width:"100%", height:44});

            this.appleButton = new fx.components.Button({label:fx.text("Continuer avec Apple"), type:"borderOnly", className:"social-login-btn social-login-btn--apple"});
            this.addChild(this.appleButton, {width:"100%", height:44});
        }

        
    }

    postCreate()
    {
        super.postCreate();

        // conditions string
        this.conditions = new fx.components.Text({text:fx.text("En poursuivant, vous acceptez lez conditions generales"), className:"conditions-string link"});
        this.addChild( this.conditions, {width : "90%"});
    }

    onReady()
    {
        super.onReady();

        this.on("click", this.onConfirm, this.okButton);
        this.on("enter", this.onConfirm, this.loginInput);
        this.on("enter", this.onConfirm, this.passwordInput);
        //this.on("click", this.onLogin, this.login);
        this.on("click", this.onConditions, this.conditions);

        if (this.googleButton) this.on("click", this.onGoogle, this.googleButton);
        if (this.appleButton) this.on("click", this.onApple, this.appleButton);

        this.loginInput.focus();
    }

    onGoogle()
    {
        this._socialLogin("google");
    }

    onApple()
    {
        this._socialLogin("apple");
    }

    _socialLogin(provider)
    {
        this.loading(true, fx.text("Connexion"), "light");

        window.flxSocialAuth.login(provider, {
            creationid : this.data.creation.id,
            accountid  : this.data.account.id,
            onResult   : (resp) => this._onSocialResult(resp),
        });
    }

    _onSocialResult(resp)
    {
        if (resp && resp.ok && resp.user)
        {
            // social find-or-creates the account: seed the model (emits
            // "login-succeed", handled in onDataEvent below).
            this.data.account.setData(resp.user, "login-succeed");
            // appel ajax au front pour faire un reaffectphotos
        }
        else
        {
            this.loading(false);
            this._error.text = fx.text("La connexion n'a pas abouti. Veuillez réessayer.");
            this._error.removeClass("hidden");
        }
    }

    /*onLogin()
    {
        this.close();
        this.data.event("login-popup");
    }*/
    
    onConditions()
    {
        this.data.event("show-conditions");
    }

    onConfirm()
    {
        this._error.addClass("hidden");
        this.passwordInput.removeClass("error");
        this.loginInput.removeClass("error");

        if (!Utils.validateEmail(this.loginInput.value))
        {
            this._error.text = fx.text("Le format de votre email est incorrect");
            this._error.removeClass("hidden");

            this.loginInput.addClass("error");
        }
        else
        if (this.passwordInput.value.length < 6)
        {
            this._error.text = fx.text("Votre mot de passe doit contenir au moins 6 caractères");
            this._error.removeClass("hidden");
            this.passwordInput.addClass("error");
        }
        else
        if (this.loginInput.value && this.passwordInput.value)
        {
            this.register(this.loginInput.value, this.passwordInput.value);
        }
        else
        {
            this._error.text = fx.text("Veuillez saisir votre email et mot de passe");
            this._error.removeClass("hidden");

            this.passwordInput.addClass("error");
            this.loginInput.addClass("error");
        }
    }
 
    register(email, password)
    {
        this.loading(true, fx.text("Enregistrement"), "light");

        this.data.account.register( email, password, this.data.creation.id, this.data.account.id);

    }

    onDataEvent(event)
    {
        super.onDataEvent(event);
        
        switch(event.type)
        {
            case "register-sent" :
                this._error.addClass("hidden");
                this.loginInput.removeClass("error");
                this.passwordInput.removeClass("error");
            break;

            case "register-succeed" :
            //case "update-url-error" :
            //case "update-url-complete" :
                this.close();
                this.loading(false);
                this.data.event("register-complete");
            break;

            // social sign-in find-or-creates the account, so it logs the user in
            case "login-succeed" :
                this.close();
                this.loading(false);
                this.data.event("login-complete");
            break;

            case "register-failed" :
                this.loading(false);
                this._error.text = fx.text("Mot de passe incorrect");
                this._error.removeClass("hidden");
                this.passwordInput.addClass("error");
            break;
        }
    }




});